import React from '../../../../../_snowpack/pkg/react.js';
import { useLocation, useHistory } from '../../../../../_snowpack/pkg/react-router-dom.js';
import isEqual from '../../../../../_snowpack/pkg/lodash/isEqual.js';
import { useTenant } from '../../../../hooks/index.js';
import DropDown from './dropdown.js';

function TenantMenu() {
  const {
    tenant: {
      id: tenantId
    },
    tenants,
    setTenant
  } = useTenant();
  const location = useLocation();
  const history = useHistory();
  const {
    tenant: currentTenant
  } = (tenants === null || tenants === void 0 ? void 0 : tenants.find(({
    tenant: t
  }) => t.id === tenantId)) || {};
  const items = (tenants === null || tenants === void 0 ? void 0 : tenants.map(({
    tenant
  }) => tenant)) || [];

  const handleChangeTenant = ({
    selectedItem
  }) => {
    if (location.pathname.includes('get-access')) {
      return;
    } // *NOTE: the isEqual comparison is to avoid set the tenant again when changing the default language


    if (selectedItem && !isEqual(selectedItem, currentTenant)) {
      setTenant(selectedItem);
      const firstPath = location.pathname.match(/^(\/[^/]+)/);
      history.replace(firstPath ? firstPath[0] : '/');
      /**
       * Ensure that you can use global search directly
       * after selecting a tenant
       */

      document.activeElement.blur();
    }
  };

  if (!currentTenant) {
    return null;
  }

  return /*#__PURE__*/React.createElement(DropDown, {
    items: items,
    onTenantChange: handleChangeTenant,
    selected: currentTenant
  });
}

export default TenantMenu;